import { useCreateDonation } from "@api/donationService";
import DonationEdit from "./DonationEdit";

export default function DonationCreate() {
    return <DonationEdit
        mutation={useCreateDonation}
        title={'New Donation'}
        create
    />
}
